import { useCallback } from 'react';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

import { selectData } from '../../store/selectors.ts';
import { useAttach } from '../../store/useAttach.js';

import { scriptsStore, type ScriptsStoreState } from './ScriptsStore.ts';

export function useScriptsData() {
  useAttach(scriptsStore, 'useScriptsData');

  return useStoreWithEqualityFn(scriptsStore.store, selectData, shallow);
}
useScriptsData.store = scriptsStore;

export function useScripts() {
  useAttach(scriptsStore, 'useScripts');

  const select = useCallback((state: ScriptsStoreState) => {
    return {
      byId: state.byId,
      app: state.app,
      appInstance: state.appInstance,
      isLoading: state.isLoading,
      error: state.error,
    };
  }, []);

  const result = useStoreWithEqualityFn(scriptsStore.store, select, shallow);

  return result;
}
useScripts.store = scriptsStore;

export function useScript({ scriptId }: { scriptId?: string } = {}) {
  useAttach(scriptsStore, 'useScript');

  const select = useCallback(
    (state: ScriptsStoreState) => {
      return {
        script: scriptId != null ? (state.byId?.[scriptId] ?? null) : null,
        app: state.app,
        appInstance: state.appInstance,
        isLoading: state.isLoading,
        error: state.error,
      };
    },
    [scriptId],
  );

  const result = useStoreWithEqualityFn(scriptsStore.store, select, shallow);

  return result;
}
useScript.store = scriptsStore;

export function useScriptsAttach() {
  useAttach(scriptsStore, 'useScriptsAttach');
}
useScriptsAttach.store = scriptsStore;
